<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <EXCMTeamUserDataForm
              :team="team"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMTeamUserDataForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmteamuserdata/create')

export default {
  components: {
    EXCMTeamUserDataForm,
    Loader
  },

  props: {
    team: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.$route.name === 'EXCMTeamShow' || this.$route.name === 'EXCMTeamUpdate') {
        this.$store.state.modals.excmteamuserdata.create.created = 1
        this.$store.state.modals.excmteamuserdata.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMTeamUserDataUpdate', params: { id: created['@id'] } })
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
